import { Component, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NgbCarouselConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ScrollToConfigOptions,
  ScrollToService,
} from '@nicky-lenaers/ngx-scroll-to';

import { OwlOptions } from 'ngx-owl-carousel-o';
import { VideoModalComponent } from './video-modal/video-modal.component';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomePageComponent {
  companiesCarousel: OwlOptions = {
    items: 3,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    margin: 0,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      768: {
        items: 3,
      },
    },
  };
  carouselImgs = [
    'assets/images/homepage/companies/srg.jpg',
    'assets/images/homepage/companies/true-wood.png',
    'assets/images/homepage/companies/vitality-living.png',
    'assets/images/homepage/companies/sodalis.png',
    'assets/images/homepage/companies/plc.svg',
    'assets/images/homepage/companies/heritage-communities.png',
    'assets/images/homepage/companies/download.svg',
    'assets/images/homepage/companies/distinctive-living.png',
    'assets/images/homepage/companies/discovery.png',
    'assets/images/homepage/companies/bsl-cmyk.png',
    'assets/images/homepage/companies/age-well.png',
    'assets/images/homepage/companies/aegis-living-logo-blue.svg',
    'assets/images/homepage/companies/ASL-Horizontal-Logo-2.svg',
  ];
  constructor(
    config: NgbCarouselConfig,
    private title: Title,
    private meta: Meta,
    private scrollToService: ScrollToService,
    private modal: NgbModal
  ) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

    this.meta.addTag({
      name: 'description',
      content:
        'Build a more active, engaged senior living community with simplified data management and insights to improve resident quality of life',
    });
    this.title.setTitle(
      'TSOLife | Happier more connected senior living community'
    );
  }

  triggerScrollTo(target: string) {
    const config: ScrollToConfigOptions = {
      target,
    };
    this.scrollToService.scrollTo(config);
  }

  openVideo() {
    this.modal.open(VideoModalComponent, {
      centered: true,
      size: 'xl',
    });
  }
}
